import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CoveoCommerceState } from "@NA/Store/Data/CoveoCommerceState";
import { CoveoToken } from "../../Services/CoveoApiService";
import { Draft } from "immer";

export const CoveoActions = {
    BEGIN_LOAD_ENGINE: "Data/Coveo/BeginLoadCoveoEngine",
    LOAD_TOKEN: "Data/Coveo/LoadCoveoToken",
    LOAD_ENGINE: "Data/Coveo/LoadCoveoEngine",
    COMPLETE_LOAD_ENGINE: "Data/Coveo/CompleteLoadCoveoEngine",
    SET_PROVIDER_DEFINITION: "Data/Coveo/SetCoveoProviderDefinition",
    BEGIN_LOAD_STATIC_STATE: "Data/Coveo/BeginLoadCoveoStaticState",
    LOAD_STATIC_STATE: "Data/Coveo/LoadCoveoStaticState",
    COMPLETE_LOAD_STATIC_STATE: "Data/Coveo/CompleteLoadCoveoStaticState",
    SET_CART_ITEMS: "Data/Coveo/SetCartItems",
    LOAD_REALTIME_PRICING: "Data/Coveo/LoadRealTimePricing",
    COMPLETE_LOAD_PLP: "Data/Coveo/CompleteLoadPLP",
};

const initialState: CoveoCommerceState = {
    token: null,
    isEngineLoading: false,
    isEngineLoadedOnClient: false,
    engineDefinition: null,
    providerDefinition: null,
    navigatorContext: null,
    isStaticStateLoading: false,
    staticState: null,
    cartItems: null,
    loadingRealTimePricing: false,
    loadedCompletePLP: false,
};

const reducer = {
    [CoveoActions.BEGIN_LOAD_ENGINE]: (draft: Draft<CoveoCommerceState>) => {
        draft.isEngineLoading = true;
    },
    [CoveoActions.LOAD_TOKEN]: (draft: Draft<CoveoCommerceState>, action: { token: CoveoToken }) => {
        draft.token = action.token;
    },
    [CoveoActions.LOAD_ENGINE]: (
        draft: Draft<CoveoCommerceState>,
        action: { engineDefinition: any; isEngineLoadedOnClient: boolean },
    ) => {
        draft.engineDefinition = action.engineDefinition;
        draft.isEngineLoadedOnClient = action.isEngineLoadedOnClient;
    },
    [CoveoActions.COMPLETE_LOAD_ENGINE]: (draft: Draft<CoveoCommerceState>) => {
        draft.isEngineLoading = false;
    },
    // Provider Definition
    [CoveoActions.SET_PROVIDER_DEFINITION]: (
        draft: Draft<CoveoCommerceState>,
        action: { providerDefinition: any; navigatorContext: any },
    ) => {
        draft.providerDefinition = action.providerDefinition;
        draft.navigatorContext = action.navigatorContext;
    },
    // Static State
    [CoveoActions.BEGIN_LOAD_STATIC_STATE]: (draft: Draft<CoveoCommerceState>) => {
        draft.isStaticStateLoading = true;
    },
    [CoveoActions.LOAD_STATIC_STATE]: (draft: Draft<CoveoCommerceState>, action: { staticState: any }) => {
        draft.staticState = action.staticState;
    },
    [CoveoActions.COMPLETE_LOAD_STATIC_STATE]: (draft: Draft<CoveoCommerceState>) => {
        draft.isStaticStateLoading = false;
    },
    // Cart Items
    [CoveoActions.SET_CART_ITEMS]: (draft: Draft<CoveoCommerceState>, action: { cartItems: any }) => {
        draft.cartItems = action.cartItems;
    },
    // RealTime Pricing
    [CoveoActions.LOAD_REALTIME_PRICING]: (draft: Draft<CoveoCommerceState>, action: { isLoading: boolean }) => {
        draft.loadingRealTimePricing = action.isLoading;
    },

    // All actions of PLP
    [CoveoActions.COMPLETE_LOAD_PLP]: (draft:  Draft<CoveoCommerceState>, action: { isLoading: boolean }) => {
        draft.loadedCompletePLP = action.isLoading;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
